<template>
  <div class="command-palette-list">
    <div v-if="loading" class="command-palette-loading">
      <div class="loading-spinner"></div>
    </div>
    
    <div v-else-if="isEmpty" class="command-palette-empty">
      {{ emptyMessage }}
    </div>
    
    <div v-else class="command-palette-items">
      <slot></slot>
    </div>
    
    <div v-if="!loading && showFooter" class="command-palette-footer">
      <span class="footer-count" v-if="!isEmpty">{{ itemCount }} {{ itemLabel }}</span>
      <span class="footer-count" v-else>&nbsp;</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CommandPaletteList',
    props: {
      emptyMessage: {
        type: String,
        default: 'No items found'
      },
      loading: {
        type: Boolean,
        default: false
      },
      isEmpty: {
        type: Boolean,
        default: false
      },
      itemCount: {
        type: Number,
        default: 0
      },
      itemLabel: {
        type: String,
        default: 'item(s)'
      },
      showFooter: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
.command-palette-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  
  .command-palette-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-height: 100px;
    
    .loading-spinner {
      width: 20px;
      height: 20px;
      border: 2px solid var(--ld-border-default);
      border-top-color: var(--ld-border-focus);
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
  }

  .command-palette-empty {
    padding: 24px 16px;
    text-align: center;
    color: var(--ld-text-secondary);
    font-size: 14px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .command-palette-items {
    flex: 1;
    overflow-y: auto;
    min-height: 50px;
    padding: 8px 0;
  }
  
  .command-palette-footer {
    padding: 8px 16px;
    font-size: 12px;
    color: var(--ld-text-secondary);
    text-align: right;
    border-top: 1px solid var(--ld-border-default);
    flex-shrink: 0;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 